module.exports = __webpack_public_path__ + "fonts/Roboto-400-latin-ext6.c3dcdbd.woff2";